export enum LayerMapVisualizationType {
  HEATMAP = 'heatmap',
  IMAGE_HEATMAP = 'image-heatmap',
  SCATTERPLOT = 'scatterplot',
  FLOW = 'flow',
  GRID = 'grid',
}

export default LayerMapVisualizationType;
